import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, mediaUrl, apiError } from "@/lib/api";

export default function MediaUpload({ value, onChange, label = "Media", accept = "image/*,video/*" }) {
  const ref = useRef();
  const [uploading, setUploading] = useState(false);
  const [pct, setPct] = useState(0);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    setPct(0);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0, onUploadProgress: (e) => e.total && setPct(Math.round((e.loaded / e.total) * 100)) });
      onChange(data.url, data.is_video, data.poster);
      toast.success("Uploaded");
    } catch (e) {
      toast.error(apiError(e, "Upload failed"));
    } finally {
      setUploading(false);
    }
  };

  const isVid = typeof value === "string" && /\.(mp4|mov|webm)(\?|$)/i.test(value);

  return (
    <div>
      <span className="text-white/60 text-xs uppercase tracking-wide font-mono-label mb-1.5 block">{label}</span>
      <div className="flex items-center gap-3">
        <div className="h-16 w-16 rounded-lg overflow-hidden border border-white/15 bg-[#0a0a0a] flex items-center justify-center shrink-0">
          {value ? (
            isVid ? <span className="text-[9px] text-white/50">VIDEO</span> : <img src={mediaUrl(value)} alt="" className="w-full h-full object-cover" />
          ) : <Upload size={18} className="text-white/30" />}
        </div>
        <input ref={ref} type="file" accept={accept} className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid="media-upload-input" />
        <button type="button" onClick={() => ref.current.click()} disabled={uploading} className="text-sm border border-white/20 rounded-lg px-4 py-2 text-white/80 hover:border-[#D4AF37] flex items-center gap-2">
          {uploading ? <Loader2 className="animate-spin" size={14} /> : <Upload size={14} />} {uploading ? (pct < 100 ? `Uploading ${pct}%` : "Processing…") : "Upload"}
        </button>
        {value && <button type="button" onClick={() => onChange("", false)} className="text-white/40 hover:text-red-400"><X size={16} /></button>}
      </div>
    </div>
  );
}
